import React from 'react';
import { useSelector } from 'react-redux';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  Spreadsheet,
  IndentedTitleText,
} from '../../DTInfoWidget.styles';
import { getSelectedRbiStore } from 'selectors/tools';

const DTRbiSelectedStoreDetailsWidget = () => {
  const store = useSelector(getSelectedRbiStore);

  return (
    <>
      <Spreadsheet className="fs-block">
        <IndentedTitleText style={{ marginTop: '10px' }}>SELECTED STORE LOCATION</IndentedTitleText>
        <HeaderRow>
          <ResultsColumnHeader>STREET ADDRESS</ResultsColumnHeader>
          <ResultsColumnHeader>CITY</ResultsColumnHeader>
          <ResultsColumnHeader>STATE</ResultsColumnHeader>
          <ResultsColumnHeader>ZIP CODE</ResultsColumnHeader>
        </HeaderRow>
        <Row>
          <ResultsColumn>{store?.storeAddress?.address1}</ResultsColumn>
          <ResultsColumn>{store?.storeAddress?.city}</ResultsColumn>
          <ResultsColumn>{store?.storeAddress?.stateProvince}</ResultsColumn>
          <ResultsColumn>{store?.storeAddress?.postalCode}</ResultsColumn>
        </Row>
      </Spreadsheet>
    </>
  );
};

export default DTRbiSelectedStoreDetailsWidget;
